module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg21.826d4e70.jpg";